import React, { Fragment } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import style from "./styles.module.scss";
import classnames from "classnames";
import { TabName, WizzMode } from "./types";

const Navigation = ({ active, toggle, mode, role, asset }) => {
  return (
    <Nav tabs>
      <NavItem>
        <NavLink
          className={classnames({ active: active === TabName.General })}
          onClick={() => toggle(TabName.General)}
        >
          <i className="fa fa-cube mr-1" />
          General
        </NavLink>
      </NavItem>
      {mode != WizzMode.New && (
        <Fragment>
          <NavItem>
            <NavLink
              className={classnames({ active: active === TabName.Structure })}
              onClick={() => toggle(TabName.Structure)}
            >
              <i className="fa fa-sitemap mr-1" />
              Structure
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: active === TabName.Payments })}
              onClick={() => toggle(TabName.Payments)}
            >
              <i className="fa fa-money mr-1" />
              Payments
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: active === TabName.Tax })}
              onClick={() => toggle(TabName.Tax)}
            >
              <i className="fa fa-bank mr-1" />
              Tax
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: active === TabName.Groups })}
              onClick={() => toggle(TabName.Groups)}
            >
              <i className="fa fa-object-group mr-1" />
              Groups
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: active === TabName.Sinonyms })}
              onClick={() => toggle(TabName.Sinonyms)}
            >
              <i className="fa fa-asterisk mr-1" />
              Sinonyms
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: active === TabName.Currency })}
              onClick={() => toggle(TabName.Currency)}
            >
              <i className="fa fa-usd mr-1" />
              Currency
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: active === TabName.Quotes })}
              onClick={() => toggle(TabName.Quotes)}
            >
              <i className="fa fa-money mr-1" />
              Quotes
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: active === TabName.Agencies })}
              onClick={() => toggle(TabName.Agencies)}
            >
              <i className="fa fa-star mr-1" />
              Agencies
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: active === TabName.Portfolios,
              })}
              onClick={() => toggle(TabName.Portfolios)}
            >
              <i className="fa fa-briefcase mr-1" />
              Portfolios
            </NavLink>
          </NavItem>
          {asset.AssetPhysicalDenomination && (
            <NavItem>
              <NavLink
                className={classnames({
                  active: active === TabName.Denominations,
                })}
                onClick={() => toggle(TabName.Denominations)}
              >
                <i className="fa fa-file-text mr-1" />
                Denominations
              </NavLink>
            </NavItem>
          )}
          {/*role == "advisor" && (
            <NavItem>
              <NavLink
                className={classnames({
                  active: active === TabName.Fundamentals
                })}
                onClick={() => toggle(TabName.Fundamentals)}
              >
                <i className="fa fa-newspaper-o mr-1" />
                Fundamentals
              </NavLink>
            </NavItem>
              )*/}
        </Fragment>
      )}
    </Nav>
  );
};

const Mode = {
  New: "New",
  Edit: "Edit",
  View: "View",
};

export default Navigation;
